import moment from 'moment';

 export const parseDate = (date) => {
    var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
    var hour = ''+d.getHours()
    var min = ''+d.getMinutes();
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
        if (hour.length < 2) 
            hour = '0' + hour;
        if (min.length < 2) 
            min = '0' + min;
  
      return [year, month, day].join('-') + " " + hour + ":" + min;
}

export const formatDate = (date) => {
    if(!date) {
        return '';
    }
    return moment(date).format('YYYY-MM-DD');
   
  }
export const formatDatetime = (date) => {

    if(!date) {
        return '';
    }

    return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

export const formatNumber = (num,deci) => {
    return (Math.round(num * 100) / 100).toFixed(deci);
}
